import { components } from 'react-select'
import  {translateSfAccountsTypes} from '../../utils/translations'
const SelectOptWithSubtitle = (props: any) => {
    const getSubtitle = () => {
        if (props.data?.subtitle) {
            return translateSfAccountsTypes(props.data?.subtitle)
        }
        if (props.data?.value) {
            return props.data?.value
        }



    }


    return <div>
        <components.Option {...props}>
            <div>{props.data.label}</div>
            <div>
                <small style={{opacity: '0.8'}}>{getSubtitle()}</small>
            </div>
        </components.Option>
    </div>
}

export default SelectOptWithSubtitle;
